module.exports = __webpack_public_path__ + "static/MKiDN-d0bce0aa5a54a0771f0a03858a0ac31a.png";